import { render, staticRenderFns } from "./ActivitiesList.vue?vue&type=template&id=d5fb8158&scoped=true&"
import script from "./ActivitiesList.vue?vue&type=script&lang=js&"
export * from "./ActivitiesList.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesList.vue?vue&type=style&index=0&id=d5fb8158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fb8158",
  null
  
)

export default component.exports